import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { TerminalSquare } from 'lucide-react';
import { api } from '../lib/api';

/** 动态导航：链接来自 site_pages（后台页面设计器可增删页面/控制导航显示） */
export function SciNav() {
  const { pathname } = useLocation();
  const [pages, setPages] = useState<{ slug: string; title: string }[]>([
    { slug: 'home', title: '首页' },
    { slug: 'models', title: '模型目录' },
    { slug: 'pricing', title: '定价' },
  ]);

  useEffect(() => {
    fetch(api('/api/catalog/pages/nav'))
      .then(r => r.json())
      .then(d => { if (Array.isArray(d) && d.length > 0) setPages(d); })
      .catch(() => {});
  }, []);

  const hrefOf = (p: { slug: string }) => (p.slug === 'home' ? '/' : `/${p.slug}`);

  return (
    <nav className="sci-nav">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
        <Link to="/" className="flex items-center gap-2.5 group">
          <span className="relative flex h-9 w-9 items-center justify-center rounded-lg border border-[var(--line-strong)] bg-[rgba(94,242,224,0.08)] text-[var(--accent)] shadow-[var(--shadow-glow)]">
            <TerminalSquare size={18} strokeWidth={2.2} />
            <span className="absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full bg-[var(--accent)] shadow-[0_0_8px_rgba(94,242,224,0.9)]" />
          </span>
          <span className="font-display text-lg tracking-tight">
            <span className="gradient-text font-bold">CXAI-</span><span className="text-[var(--ink)] font-bold">FreeRouter</span>
          </span>
        </Link>

        <div className="flex items-center gap-8">
          <div className="hidden md:flex items-center gap-7">
            {pages.map(p => {
              const href = hrefOf(p);
              const active = pathname === href;
              return (
                <Link key={p.slug} to={href} className={`nav-link ${active ? 'active' : ''}`}>
                  {p.title}
                </Link>
              );
            })}
          </div>
          <div className="hidden sm:flex items-center gap-2 rounded-full border border-[var(--line)] bg-[rgba(255,255,255,0.03)] px-3 py-1.5">
            <span className="status-dot on" />
            <span className="hud-label !text-[0.62rem]">System Online</span>
          </div>
        </div>
      </div>
    </nav>
  );
}
